export const apiKey = process.env.NEXT_PUBLIC_API_KEY!;
